import { render, staticRenderFns } from "./diamond-pricing.vue?vue&type=template&id=d8b0e1de&scoped=true&"
import script from "./diamond-pricing.vue?vue&type=script&lang=js&"
export * from "./diamond-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b0e1de",
  null
  
)

export default component.exports